import {ButtonVariant} from "@/app/_components/Button";
import LinkButton from "@/app/_components/LinkButton";
import getLegacySitePath from "../../../../../util/getLegacySitePath";
import {Class} from "../../../../../../lib/legacyApi/fetchClassesForCourseByCampusId";
import staticUrls from "@/app/util/staticPageUrls";
import useSignInHref from "@/app/_components/layout/useSignInHref";

const NotLoggedInModalBody: React.FC<{
	class: Class;
	isConsultationRequired: boolean;
}> = ({class: classToAdd, isConsultationRequired}) => {
	const signInHref = useSignInHref();
	const actionHref = isConsultationRequired
		? staticUrls.contact
		: getLegacySitePath(
				`/admissions/registration?class=${classToAdd.class_id}`,
				classToAdd.campus_id
			);
	return (
		<div className="flex max-w-lg flex-col gap-4 p-8 pt-12">
			<h3 className="text-h4">
				Thank you for your interest in enrolling at AoPS Academy!
			</h3>
			<p>
				To enroll in this class, you must have an AoPS Academy parent account.
				If you have already created the parent account, please sign in.
				Otherwise, please{" "}
				{isConsultationRequired
					? "request a consultation"
					: "create an account"}
				.
			</p>
			<div className="flex w-full flex-col items-stretch justify-center gap-2 md:flex-row md:gap-4">
				<LinkButton
					className="mt-2 text-sm"
					variant={ButtonVariant.NAVY}
					href={signInHref}
				>
					SIGN IN
				</LinkButton>
				<LinkButton
					id={
						isConsultationRequired
							? "add-class-modal-request-consultation-button"
							: "add-class-modal-create-account-button"
					}
					className="mt-2 text-sm"
					variant={ButtonVariant.NAVY}
					href={actionHref}
				>
					{isConsultationRequired ? "REQUEST CONSULTATION" : "CREATE ACCOUNT"}
				</LinkButton>
			</div>
		</div>
	);
};

export default NotLoggedInModalBody;
